export default __webpack_public_path__ + "static/media/Electricity.20807e3b.png";